import { useState } from "react";
import { Button, ButtonGroup, Modal } from '@walmart-web/livingdesign-components';
import DOMPurify from "dompurify";

const NPOModal = (props: any) => {
  const { title, content, buttonName, isModalOpen } = props;
  const [isOpen, setIsOpen] = useState(isModalOpen);
  const clean = DOMPurify.sanitize(content, {
    ALLOWED_TAGS: ["a", "b", "i", "em", "strong", "div", "span", "p"],
    ALLOWED_ATTR: ["href", "target", "rel", "class", "id", "style"],
  });

  return (
    <>
      <Modal
        actions={
          <ButtonGroup>
            <Button variant="primary" size="large" onClick={() => setIsOpen(false)}>
              {buttonName}
            </Button>
          </ButtonGroup>
        }
        closeButtonProps={{
          "aria-label": "Close Modal",
        }}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={title}
      >
        <div dangerouslySetInnerHTML={{ __html: clean }} />
      </Modal>
    </>
  );
};

export default NPOModal;